export default "__VITE_ASSET__D4EBfW3i__"